__turbopack_context__.v({
  "bar": "DonationsYearlyChart-module-scss-module__ta78WG__bar",
  "bars": "DonationsYearlyChart-module-scss-module__ta78WG__bars",
  "label": "DonationsYearlyChart-module-scss-module__ta78WG__label",
  "labels": "DonationsYearlyChart-module-scss-module__ta78WG__labels",
  "wrapper": "DonationsYearlyChart-module-scss-module__ta78WG__wrapper",
});
